import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";    
import api from "./api";
import { getEmailLogin, setFirebase } from "./auth";

export const token = () => {
    let firebaseConfig = {
        apiKey: "AIzaSyB4kIZ-sV_7n1D6ueGXIOK9Ni3XW_5ic-I",
        authDomain: "grupourbam-7e576.firebaseapp.com",
        projectId: "grupourbam-7e576",
        storageBucket: "grupourbam-7e576.appspot.com",
        messagingSenderId: "807620388400",
        appId: "1:807620388400:web:7b4f0350702fddd04faff5"
    };
    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);
    getToken(messaging, {vapidKey: 'BGR8aOyrLW3naJQvzMhybxujvVRV17xshVNR0dzDjABSXxL_g1h5xg4tku7fF4JhIBN69npfvn93rup2UfhbW6A'}).then((currentToken) => {
        if (currentToken) {
            updateToken(currentToken)
            setFirebase(currentToken)
        } else {
        }
    }).catch((err) => {
    });
    return messaging;
}
const updateToken = async (token) => {
    let email = await getEmailLogin();
    api.post(`/clients/token`, {
        email,
        token
    }).then(function (response) {
    }).catch(function(error){
        console.log(error)
    });
}